import { RegisterLink } from "@kinde-oss/kinde-auth-react/components";
import { ImageSelectItem, Panel, Typography } from "@/components/atoms";
import { Restricted } from "@/components/pages";
import { useOperator, useProviderCode, useSiteConfig } from "@/hooks";
// import { useSignUpContext } from "../context";
import { userTypeImage, userTypes } from "../fixtures";
import { UserType } from "../types";

export const UserSelectForm = () => {
  const operator = useOperator();
  const { name, providerCode: activeOperatorCode } = operator;
  const allowedUserTypes: UserType[] = ["passenger", "executive_assistant", "travel_manager"];

  // Show only allowed user types
  const options = allowedUserTypes.map((type) => userTypes[type]).filter(Boolean); // Remove any undefined entries

  const urlProviderCode = useProviderCode();
  const { domain } = useSiteConfig();
  // Use URL provider code first, then active operator's provider code, then domain as last resort
  const code = urlProviderCode || activeOperatorCode || domain;

  if (options.length === 0) return <Restricted />;

  return (
    <div>
      <Panel>
        <div className="mb-7 flex flex-col gap-y-1.5">
          <Typography variant="h1">Sign up</Typography>
        </div>
        <div className="flex flex-col gap-y-4">
          <Typography variant="title">{`How are you primarily using ${name}?`}</Typography>
          <div className="grid grid-cols-2 gap-2.5 md:grid-cols-3 md:gap-5 lg:grid-cols-5">
            {options.map((option) => (
              <RegisterLink
                key={option.type}
                properties={{
                  utm_campaign: code,
                  utm_source: "web-app",
                  utm_content: "client",
                  utm_medium: option.type,
                }}
              >
                <ImageSelectItem src={userTypeImage[option.type]} label={option.name} />
              </RegisterLink>
            ))}
          </div>
        </div>
      </Panel>
    </div>
  );
};
